'use strict';

import jQuery from 'jquery';

/**
 * TPT Channels JS object
 */

jQuery(document).ready(function($) {
    var obj  = {}; // Instance the container object

    obj.init = function () {
      function changeChannel(channelIndicator) {

        // Get the td elements matching the data attribute
        var selector = 'td.' + channelIndicator;
        var $targets = $(selector);

        if ($targets.length > 0) {

          // Make the button pressed active across all locations
          $('.channel-link')
            .removeClass('active')
            .each(function(index, element) {
              if ($(element).attr('data-channel') === channelIndicator) {
                $(element).addClass('active');
              }
            });

          // Display the proper schedule grid column
          $targets.removeClass('show-for-large-up');

          // Hide the others
          $('td').not('.provider, ' + selector).addClass('show-for-large-up');
        }
      }

      // Button logic to switch display different channels on the grid
      $('.channel-link').on('click', function(e) {
        changeChannel($(this).attr('data-channel'));
        e.preventDefault();
      });

      if (window.location.hash) {
        changeChannel(window.location.hash.substr(1));
      }
    };

    obj.init();
});

export default {}